// import store from 'vuex/store'
import EventBus from '@/eventBus'
import store from '@/store'

const handleHintsDataFromPresenter = (socketData) => {
  // activeActivity is a setter-less getter: reassigning it throws in strict mode, so update fields in place.
  store.getters.activeActivity.numberOfHintsShown = socketData.numberOfHintsShown
  store.getters.activeActivity.hintsShowingIndex = socketData.hintsShowingIndex
  store.dispatch('updateSlide', store.getters.activeActivity)
  EventBus.$emit('hints: update-show-hints', socketData)
}

const _getIndex = (arr, id) => {
  return arr.findIndex((item) => {
    return id == item.id
  })
}

const handleCRUDHintsFromPresenter = (action, socketData, needSorting) => {
  if (action === 'create') {
    const hasHints = store.getters.activeActivity.hints && store.getters.activeActivity.hints.length
    if (!hasHints) {
      store.getters.activeActivity.hints = [socketData]
    } else {
      store.getters.activeActivity.hints.push(socketData)
    }
    store.getters.activeActivity.hints = [...new Set(store.getters.activeActivity.hints)]
  } else if (action === 'patch') {
    const hintIndex = _getIndex(store.getters.activeActivity.hints, socketData.id)
    if (hintIndex != -1) {
      store.getters.activeActivity.hints[hintIndex].title = socketData.title
      store.getters.activeActivity.hints[hintIndex].order = socketData.order
      // store.state.slide.hints[hintIndex].image = socketData.image
      // store.state.slide.hints[hintIndex].imageCropped = socketData.imageCropped
    }
  } else if (action === 'delete') {
    const hintIndex = _getIndex(store.getters.activeActivity.hints, socketData.id)
    if (hintIndex != -1) {
      store.getters.activeActivity.hints.splice(hintIndex, 1)
    }
  }
  if (needSorting) {
    store.getters.activeActivity.hints.sort((a, b) => a.order - b.order)
  }
}

export default {
  handleHintsDataFromPresenter,
  handleCRUDHintsFromPresenter,
}
